import { Avatar } from '@pocketlaw/tetris';
import { getDocumentIcon } from 'app/domains/documents';
export function DocumentBadge(props) {
    const { fileSystemDocument } = props;
    const icon = getDocumentIcon(fileSystemDocument);
    return (<Avatar size="md" appearance="primary">
      {icon}
    </Avatar>);
}
